import React from 'react';
import styled, { useTheme } from 'styled-components';
import { sizes } from 'style';

const StyledSvg = styled.svg`
  display: block;
  position: relative;
  z-index: 1;
  margin-top: -1px;
`;

const MobileSvg = styled(StyledSvg)`
  @media ${sizes.tabletPortrait} {
    display: none;
  }
`;

const DesktopSvg = styled(StyledSvg)`
  display: none;
  @media ${sizes.tabletPortrait} {
    display: block;
  }
`;

const Bg = () => {
  const theme = useTheme();

  return (
    <>
      <MobileSvg
        width="100%"
        height="100%"
        viewBox="0 0 351 135"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M0,0 C15.789895,16.8915223 35.9554522,29.3572959 61.9737878,38.2960646 C117.201109,51.9219132 129.172158,41.9799677 184.254778,57.0649077 C255.481528,81.4027358 243.891184,101.137253 297.333761,125.185478 C308.547921,129.70169 326.057766,132.610896 351,133.913096 L351,0 L0,0 Z"
            id="Path"
            fill={theme.colors.black}
          />
        </g>
      </MobileSvg>
      <DesktopSvg
        width="100%"
        height="100%"
        viewBox="0 0 920 180"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M0,0 L920,0 C920,107.962621 920,161.427278 920,161.427278 C873.223813,173.248501 762.169931,184.003499 665.96858,176.899483 C517.331017,161.427278 524.446639,138.507584 359.909029,104.530669 C271.507913,87.819886 217.669734,95.4264245 130.882976,66.4046369 C77.5104808,48.4486045 34.0984083,26.6581614 0,0 Z"
            id="Path"
            fill={theme.colors.black}
          />
        </g>
      </DesktopSvg>
    </>
  );
};

export default Bg;
